import React from "react";
import { connect } from "react-redux";
import {
  getIntervalReports,
  getIntervalBillReport,
} from "../../actions/ReportsActions";
import { Container, Tab } from "semantic-ui-react";
import GeneralStatistics from "./GeneralStatistics";
import IntervalBillReport from "./IntervalBillReport";
import BillFilter from "./BillFilter";

class Reports extends React.Component {
  state = {
    fetch: false,
    filterData: {
      fromDate: "",
      toDate: "",
      selectedPaymentType: null,
      selectedBillStatus: null,
    },
    activeIndex: 0,
  };

  handleDataChange = (fromDate, toDate, selectedPaymentType, selectedBillStatus) => {
    this.setState({
      filterData: {
        fromDate: fromDate,
        toDate: toDate,
        selectedPaymentType: selectedPaymentType,
        selectedBillStatus: selectedBillStatus
      },
    });
  };

  handleFetchData = () => {
    this.setState({ fetch: true });
  };

  render() {
    return (
      <Container>
        <BillFilter
          onDataChange={this.handleDataChange}
          onFetchData={this.handleFetchData}
        />
        <Tab
          activeIndex={this.state.activeIndex}
          onTabChange={(e, { activeIndex }) => this.setState({ activeIndex })}
          renderActiveOnly={true}
          menu={{ pointing: true }}
          panes={[
            {
              menuItem: "آمارکلی",
              render: () => (
                <Tab.Pane attached={false}>
                  <GeneralStatistics
                    fetch={this.state.fetch}
                    filterData={this.state.filterData}
                  />
                </Tab.Pane>
              ),
            },
            {
              menuItem: "فاکتورها",
              render: () => (
                <Tab.Pane attached={false}>
                  <IntervalBillReport
                    fetch={this.state.fetch}
                    filterData={this.state.filterData}
                  />
                </Tab.Pane>
              ),
            },
          ]}
        />
      </Container>
    );
  }
}

export default Reports;
